import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import moment from 'moment';

import Table from './Table';
import OBDTable from './OBDTable';

const styles = StyleSheet.create({
  section: {
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    paddingLeft: 10,
    flexGrow: 1,
    alignItems: 'center',
  },
  section__up: {
    paddingTop: 5,
    paddingBottom: 5,
    paddingRight: 10,
    paddingLeft: 10,
    flexGrow: 1,
  },

  invoice__date: {
    marginTop: 20,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  invoice__date__Left: {
    borderRadius: '5px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexGrow: 4,
    backgroundColor: 'rgba(231, 236, 244, .8)',
  },

  gray__text: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '400',
    textTransform: 'capitalize',
  },

  gray__text_up: {
    fontSize: 9,
    fontFamily: 'Roboto',
    fontWeight: '600',
  },

  mr1: {
    flexGrow: 1,
    alignItems: 'flex-start',
    borderRight: '1px solid #8A9EAF',
    paddingTop: 6,
    paddingBottom: 6,
  },
  mr__l: {
    flexGrow: 1,
    alignItems: 'flex-start',
    paddingTop: 6,
    paddingBottom: 6,
  },
});

export default function InspectionDetails({ data }) {
  const { inspections = [], recommendations = [] } = data || '';

  return (
    <>
      {inspections?.map((inspection) => {
        const { customParts = [], cwParts = [], pwParts = [] } = inspection;
        const partsData = [...cwParts, ...pwParts, ...customParts];

        return (
          <>
            <View style={styles.invoice__date} wrap={false}>
              <View style={styles.invoice__date__Left}>
                <View style={styles.mr1}>
                  <View style={styles.section__up}>
                    <Text style={styles.gray__text_up}>Inspection Title</Text>
                  </View>
                  <View style={styles.section__up}>
                    <Text style={styles.gray__text}>{inspection?.title}</Text>
                  </View>
                </View>

                <View style={styles.mr1}>
                  <View style={styles.section__up}>
                    <Text style={styles.gray__text_up}>Inspection Type</Text>
                  </View>
                  <View style={styles.section__up}>
                    <Text style={styles.gray__text}>{inspection?.type}</Text>
                  </View>
                </View>
                <View style={styles.mr1}>
                  <View style={styles.section__up}>
                    <Text style={styles.gray__text_up}>Inspected By</Text>
                  </View>
                  <View style={styles.section__up}>
                    <Text style={styles.gray__text}>
                      {inspection?.user?.name}
                    </Text>
                  </View>
                </View>
                <View style={styles.mr__l}>
                  <View style={styles.section__up}>
                    <Text style={styles.gray__text_up}>Inspection Date</Text>
                  </View>
                  <View style={styles.section__up}>
                    <Text style={styles.gray__text}>
                      {inspection?.createdAt
                        ? moment(inspection.createdAt).format('MM/DD/YYYY')
                        : ''}
                    </Text>
                  </View>
                </View>
              </View>
            </View>
            <Table partsData={partsData} />
            <OBDTable
              recommendations={recommendations?.filter(
                (r) =>
                  r.inspectionId === inspection?.id &&
                  r.issueType === 'obdError',
              )}
            />
          </>
        );
      })}
    </>
  );
}
